import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { MdOutlineDelete } from "react-icons/md";

function DeleteReleaseNoteModal({ isModalOpen, setIsModalOpen, releaseNoteToDelete, onConfirmDelete, isDeleting,handleCloseVersionModal }) {
    const handleClose = () => {
        setIsModalOpen(false);
        handleCloseVersionModal();
    };

    const handleConfirm = () => {
            if (releaseNoteToDelete && onConfirmDelete) {
            onConfirmDelete(releaseNoteToDelete);
            handleCloseVersionModal();
        }
    };

    return (
        <Modal isOpen={isModalOpen} toggle={handleClose} centered>
            <ModalHeader toggle={handleClose} className="modal-colored-header bg-danger ">
                <div className="d-flex align-items-center">
                    <MdOutlineDelete style={{ fontSize: '24px', marginRight: '10px', color: 'white' }} />
                    <span style={{ color: 'white' }}>Delete Release Note</span>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="text-center">
                    <MdOutlineDelete style={{ fontSize: '48px', color: '#dc3545', marginBottom: '15px' }} />
                    <h5 className="mb-3">Are you sure you want to delete this release note?</h5>
                    {releaseNoteToDelete && (
                        <div className="alert alert-warning">
                            <strong>Title:</strong> {releaseNoteToDelete.title}
                        </div>
                    )}
                    <p className="text-muted mb-0">
                        This action cannot be undone. The release note will be permanently deleted.
                    </p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={handleClose} disabled={isDeleting}>
                    Cancel
                </Button>
                <Button 
                    color="danger" 
                    onClick={handleConfirm}
                    disabled={isDeleting}
                >
                    {isDeleting ? 'Deleting...' : 'Delete Release Note'}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default DeleteReleaseNoteModal;

